const postRequest = (url = ``, data = {}) =>
	fetch(url, {
		method: "POST",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrer: "no-referrer",
		body: JSON.stringify(data),
	});

export const post = (url = ``, data = {}) =>
	postRequest(url, data).then((response) => response.json());

export const get = (url = ``) =>
	fetch(url, {
		method: "GET",
		mode: "cors",
		cache: "no-cache",
		credentials: "same-origin",
		headers: {
			"Content-Type": "application/json",
		},
		redirect: "follow",
		referrer: "no-referrer",
	}).then((response) => response.json());

// Rejects on non-2xx responses and on { isSuccess: false }, for requests where a failure must not look like success
const postOrThrow = (url = ``, data = {}) =>
	postRequest(url, data)
		.then((response) => {
			if (!response.ok) {
				throw new Error(`${url} responded with ${response.status}`);
			}

			return response.json();
		})
		.then((body) => {
			if (body?.isSuccess === false) {
				throw new Error(`${url} failed: ${body.error?.message}`);
			}

			return body;
		});

export const switchInsurance = (cartId, cartItemId, insuranceId) => {
	if (insuranceId) {
		return post("/cart/api/setInsurance", { cartItemId, insuranceId });
	} else {
		return post("/cart/api/removeInsurance", { cartId, cartItemId });
	}
};

export const setConfigService = (
	cartItemId,
	serviceProductId,
	optionProductIds,
	materialId,
	serviceGroupId,
) => {
	if (serviceProductId) {
		return postOrThrow("/cart/api/setConfigService", {
			cartItemId,
			materialId,
			serviceProductId,
			optionProductIds,
			serviceGroupId,
		});
	} else {
		return post("/cart/api/removeConfigService", { cartItemId });
	}
};

export const removeConfigService = (
	cartItemId,
	serviceProductId,
	optionProductIds,
) =>
	post("/cart/api/removeConfigService", {
		cartItemId,
		serviceProductId,
		optionProductIds,
	});

export const getConfigServices = (sku) =>
	get(`/api-product/config-services?sku=${encodeURIComponent(sku)}`);

export const getSubscriptionTermsData = ({
	productId,
	selectedConfigServiceIds,
}) =>
	post("/addtocartpopup/getFlexCalculationData", {
		productId: `${productId}`,
		selectedConfigServiceIds,
	});

export const getPopupData = ({
	productId,
	renewalPeriod,
	categoryId,
	configBundleConfigurationId,
	includeStrings,
}) =>
	post("/addtocartpopup/getPopupData", {
		productId: `${productId}`,
        categoryId: categoryId,
		renewalPeriod,
		configBundleConfigurationId,
		includeStrings,
	});

export const getSubscriptionData = ({
	productId,
	price,
	taxRate,
	isConfigBundle,
	subGroup,
	renewalPeriod,
	isConfigServiceIncluded,
	configServices,
	configBundleConfigurationId,
	includeStrings,
}) =>
	post("/addtocartpopup/getSubscriptionData", {
		productId,
		price: price,
		taxRate,
		isConfigBundle,
		subGroup,
		renewalPeriod,
		isConfigServiceIncluded,
		configServices,
		configBundleConfigurationId,
		includeStrings,
	});

export const setPopupEnabled = (isEnabled) =>
	post("/addtocartpopup/enable", { isEnabled });
